import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=316b4f0e&scoped=true"
import script from "./viewDetails.vue?vue&type=script&lang=js"
export * from "./viewDetails.vue?vue&type=script&lang=js"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=316b4f0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b4f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316b4f0e')) {
      api.createRecord('316b4f0e', component.options)
    } else {
      api.reload('316b4f0e', component.options)
    }
    module.hot.accept("./viewDetails.vue?vue&type=template&id=316b4f0e&scoped=true", function () {
      api.rerender('316b4f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/enterprise/list/components/viewDetails.vue"
export default component.exports